<template src="./edizioneFormazione.html"></template>

<script>
import {
    get_docenti,
    get_corsi,
    get_edizioneDettaglio,
    set_edizione,
    set_aziendeEdizione,
    set_partecipante,
    delete_partecipante,
    conferma_edizione,
    genera_attestati,
    rigenera_attestato,
    download_attestato,
} from "@/api/api.formazione.js";
import { get_listaClienti } from "@/api/api.dati.js";
import CampoData from "@/components/cliente/CampoData.vue";

export default {
    components: { CampoData },

    data: () => ({
        step: 1,
        stato: "Programmato",

        edizione: { edizioneId: 0, corsoId: null, docenteId: null, data: null, ore: null, modalita: "", luogo: "" },
        dataRilascio: null,

        corsi: [],
        docenti: [],
        aziendeDisponibili: [],
        aziendeSelezionate: [],
        partecipanti: [],

        modalitaSuggerite: ["Videoconferenza", "Presso sede cliente", "In aula"],

        dialogPartecipante: false,
        editedPartecipante: {},

        headersPartecipanti: [
            { text: "Azienda", value: "ragioneSociale", sortable: false },
            { text: "Nome", value: "nome", sortable: false },
            { text: "Cognome", value: "cognome", sortable: false },
            { text: "Azioni", value: "azioni", sortable: false },
        ],

        headersPartecipantiConfermati: [
            { text: "Azienda", value: "ragioneSociale", sortable: false },
            { text: "Nome", value: "nome", sortable: false },
            { text: "Cognome", value: "cognome", sortable: false },
            { text: "Attestato", value: "azioni", sortable: false },
        ],
    }),

    methods: {
        async caricaAnagrafiche() {
            const [resDocenti, resCorsi, resAziende] = await Promise.all([
                get_docenti(),
                get_corsi(),
                get_listaClienti({ Cliente: true, Gruppo: "Tutti" }),
            ]);
            this.docenti = resDocenti.data;
            this.corsi = resCorsi.data;
            this.aziendeDisponibili = resAziende.data;

            if (!this.edizione.docenteId && this.docenti.length) this.edizione.docenteId = this.docenti[0].docenteId;
        },

        async caricaEsistente(id) {
            const res = await get_edizioneDettaglio(id);
            if (!res.data) {
                this.$toast.alert("Edizione non trovata");
                this.$router.push({ path: "/formazione" });
                return;
            }
            this.applicaDettaglio(res.data);
            this.step = this.calcolaStepIniziale();
        },

        async ricaricaDettaglio() {
            if (!this.edizione.edizioneId) return;
            const res = await get_edizioneDettaglio(this.edizione.edizioneId);
            if (res.data) this.applicaDettaglio(res.data);
        },

        applicaDettaglio(dati) {
            this.edizione = {
                edizioneId: dati.edizioneId,
                corsoId: dati.corsoId,
                docenteId: dati.docenteId,
                data: dati.data,
                ore: dati.ore,
                modalita: dati.modalita,
                luogo: dati.luogo,
            };
            this.stato = dati.stato;
            this.dataRilascio = dati.dataRilascio;
            this.aziendeSelezionate = dati.aziende.map((a) => a.companyCode);
            this.partecipanti = dati.partecipanti;
        },

        calcolaStepIniziale() {
            if (!this.edizione.corsoId) return 1;
            if (!this.aziendeSelezionate.length) return 2;
            if (!this.partecipanti.length) return 3;
            if (!this.edizione.data || !this.edizione.ore || !this.edizione.modalita) return 4;
            return 5;
        },

        async salvaStep1AndContinue() {
            const res = await set_edizione(this.edizione);
            if (!isNaN(res.data)) {
                this.edizione.edizioneId = parseInt(res.data);
                this.step = 2;
            } else {
                this.$toast.alert(res.data);
            }
        },

        async salvaStep2AndContinue() {
            const res = await set_aziendeEdizione({ edizioneId: this.edizione.edizioneId, companyCodes: this.aziendeSelezionate });
            if (res.data === "OK") {
                this.step = 3;
            } else {
                this.$toast.alert(res.data);
            }
        },

        async salvaStep4AndContinue() {
            const res = await set_edizione(this.edizione);
            if (!isNaN(res.data)) {
                this.step = 5;
            } else {
                this.$toast.alert(res.data);
            }
        },

        // L'edizione viene creata mesi prima del corso: si puo' salvare in qualunque momento e riprendere piu' tardi.
        // Resta "Programmato" finche' non la si conferma a corso concluso.
        async salvaEChiudi() {
            const res = await set_edizione(this.edizione);
            if (!isNaN(res.data)) {
                this.$toast.info("Edizione salvata come programmata");
                this.$router.push({ path: "/formazione" });
            } else {
                this.$toast.alert(res.data);
            }
        },

        apriDialogPartecipante(item = null) {
            this.editedPartecipante = item
                ? { ...item }
                : {
                      partecipanteId: 0,
                      edizioneId: this.edizione.edizioneId,
                      companyCode: this.aziendeSelezionate.length === 1 ? this.aziendeSelezionate[0] : "",
                      nome: "",
                      cognome: "",
                  };
            this.dialogPartecipante = true;
        },

        async salvaPartecipante() {
            if (!this.editedPartecipante.nome || !this.editedPartecipante.cognome || !this.editedPartecipante.companyCode) {
                this.$toast.alert("Azienda, nome e cognome sono obbligatori");
                return;
            }

            const res = await set_partecipante(this.editedPartecipante);
            if (!isNaN(res.data)) {
                this.dialogPartecipante = false;
                await this.ricaricaDettaglio();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async eliminaPartecipante(item) {
            let confirm = await this.$confirm.open(
                "Elimina partecipante",
                "Rimuovere <b>" + item.nome + " " + item.cognome + "</b> da questa edizione?"
            );
            if (!confirm) return;

            const res = await delete_partecipante(item.partecipanteId);
            if (res.data === "OK") {
                await this.ricaricaDettaglio();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async confermaEdizione() {
            let confirm = await this.$confirm.open(
                "Conferma edizione",
                (this.corsoNonConcluso
                    ? "<b>Attenzione:</b> la data del corso (" + this.formattaData(this.edizione.data) + ") non e' ancora passata.<br><br>"
                    : "") +
                    "Confermare questa edizione? Dopo la conferma non sara' piu' possibile modificare aziende, partecipanti o dati dell'edizione: verranno generati gli attestati e inviata la mail alle aziende."
            );
            if (!confirm) return;

            const res = await conferma_edizione({ edizioneId: this.edizione.edizioneId, dataRilascio: this.dataRilascio });
            if (res.data === "OK") {
                this.$toast.info("Edizione confermata e attestati generati/inviati");
            } else if (res.data.startsWith("Edizione confermata")) {
                this.$toast.alert(res.data);
            } else {
                this.$toast.alert(res.data);
                return;
            }
            await this.ricaricaDettaglio();
        },

        async generaTuttiGliAttestati() {
            const res = await genera_attestati(this.edizione.edizioneId);
            this.$toast.info(res.data === "OK" ? "Attestati generati" : res.data);
            await this.ricaricaDettaglio();
        },

        async rigeneraAttestato(item) {
            let confirm = await this.$confirm.open(
                "Rigenera attestato",
                "Rigenerare l'attestato di <b>" + item.nome + " " + item.cognome + "</b>? Il PDF verra' sovrascritto nella cartella del cliente."
            );
            if (!confirm) return;

            const res = await rigenera_attestato(item.partecipanteId);
            if (res.data === "OK") {
                this.$toast.info("Attestato rigenerato");
                await this.ricaricaDettaglio();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async scaricaAttestatoPartecipante(item) {
            try {
                const res = await download_attestato(item.partecipanteId);
                const blob = new Blob([res.data], { type: "application/pdf" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `Attestato_${item.nome}_${item.cognome}.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.$toast.alert("Attestato non disponibile");
            }
        },

        formattaData(data) {
            if (!data) return "";
            try {
                return this.$i2kFunctions.formatISODate(data.substring(0, 10));
            } catch {
                return data;
            }
        },
    },

    created() {
        if (this.role !== "admin") this.$router.push({ path: "/" });
    },

    async mounted() {
        await this.caricaAnagrafiche();
        const id = this.$route.params.id;
        if (id && id !== "nuova") {
            await this.caricaEsistente(id);
        }
    },

    computed: {
        role() {
            return this.$store.getters["user/getRole"];
        },

        corsoSelezionato() {
            return this.corsi.find((c) => c.corsoId === this.edizione.corsoId) || null;
        },

        // True se la data del corso e' ancora futura (o assente): la conferma e' pensata per corsi gia' conclusi.
        corsoNonConcluso() {
            if (!this.edizione.data) return true;
            return new Date(this.edizione.data.substring(0, 10)) >= new Date(new Date().toISOString().substring(0, 10));
        },

        nomeCorsoSelezionato() {
            const corso = this.corsi.find((c) => c.corsoId === this.edizione.corsoId);
            return corso ? corso.nomeBreve : "";
        },

        corsiSelezionabili() {
            return this.corsi.filter((c) => c.enabled || c.corsoId === this.edizione.corsoId);
        },

        aziendeSelezionateOggetti() {
            return this.aziendeDisponibili.filter((a) => this.aziendeSelezionate.includes(a.companyCode));
        },
    },
};
</script>
